<template>
<div>

	<button v-show="!hasSignature && !readonly" class="btn btn-dark mr-2" type="button" v-on:click="getSignature">
		<i class="fa fa-pencil-alt"></i>
		Get Signature...
	</button>
	<div v-show="hasSignature">
		<canvas
			ref="displayCanvas"
			width="161"
			height="75"
			v-on:click="getSignature">	
		</canvas>
		<span v-if="!hideName">{{signerName}}</span>
	</div>
	<button v-if="!readonly && !hideSkipSignature" class="btn btn-light" v-on:click="skipSignature">Skip Signature...</button>
	<modal-dialog
		:modal-visible="sigPadOpen"
		:title="modalTitle"
		confirm-button-text="OK"
		v-on:closeModal="closeSigPad"
		v-on:confirm="acceptSig">

		<template v-if="!sigSkipped">
			<button class="btn btn-light btn-sm float-right" type="button" v-on:click="clearPad">
				<i class="fa fa-eraser"></i>
				Clear
			</button>

			<p>Do not exit the signature bounds</p>

			<canvas
				width="322"
				height="150"
				class="capture-canvas"
				ref="sigCanvas"
				id="sigCanvas">		
			</canvas>

			<input :readonly="externalSignerName" required type="text" v-model="signerName" class="form-control" placeholder="Name of Individual">
		</template>
		<input v-else type="text" v-model="signerName" class="form-control" placeholder="Reason for skipping signature">

	</modal-dialog>
</div>
</template>
<script type="text/javascript">
import ModalDialog from "./ModalDialog"

export default {
	name: "SignatureField",
	components: {
		ModalDialog
	},
	props: ["value","readonly","externalSignerName","hideSkipSignature","hideName"],
	watch: {
		value() {
			this.setInternalValues()
		},
		externalSignerName() {
			this.signerName = this.externalSignerName
		}
	},
	data() {
		return {
			hasSignature: false,
			signatureTrail: [],
			lastPosition: {},
			sigPadOpen: false,
			capturingMouse: false,
			mouseX: 0,
			mouseY: 0,
			client: {},
			rect: null,
			canvas: null,
			context: null,
			signerName: "",
			sigSkipped: false,
			modalTitle: "Sign your name please"
		}
	},
	methods: {
		closeSigPad() {
			this.$store.isUserDrawing = false
			this.sigPadOpen = false
			this.toggleFullScreen()
		},
		setInternalValues() {
			if (this.value != "") {
				let valueObj = {}

				try {
					if (typeof this.value == 'string') 
						valueObj = JSON.parse(this.value)
					else
						valueObj = this.value

					this.signatureTrail = valueObj.trail
					this.signerName = valueObj.name

					if (this.externalSignerName)
						this.signerName = this.externalSignerName

					if (this.signatureTrail.length > 0)
						this.hasSignature = true
				}
				catch (e) {}

				this.renderDisplayCanvas()
				
			} else {
				this.clearPad()
			}
		},
		renderDisplayCanvas() {
			let vm = this

			vm.$nextTick(() => {
				vm.canvas = vm.$refs.displayCanvas

				if (vm.canvas) {
					vm.rect = vm.canvas.getBoundingClientRect()
					vm.context = vm.canvas.getContext("2d");

					vm.context.clearRect(0, 0, vm.canvas.width, vm.canvas.height);

					vm.signatureTrail.forEach(position => {
						vm.context.beginPath()
						vm.context.moveTo(vm.lastPosition.x/2, vm.lastPosition.y/2)
						vm.context.lineTo(position.x/2, position.y/2)
						vm.context.stroke()

						vm.lastPosition = position
					})
				}
			})
		},
		addEventListeners(canvas) {
			let vm = this

			canvas.addEventListener("touchstart",vm.touchDown,false)
			canvas.addEventListener("touchend",vm.touchUp,false)
			canvas.addEventListener("touchmove",vm.touchMove,false)
			canvas.addEventListener("mousedown",vm.mouseDown,false)
			canvas.addEventListener("mousemove",vm.mouseMove,false)
			
			document.body.addEventListener("mouseup", vm.mouseUp, false);
			document.body.addEventListener("touchcancel", vm.touchUp, false);
		},
		removeEventListeners() {
			let vm = this

			vm.canvas = vm.$refs.sigCanvas

			if (vm.canvas) {
				vm.canvas.removeEventListener("touchstart",vm.mouseDown)
				vm.canvas.removeEventListener("touchend",vm.mouseUp)
				vm.canvas.removeEventListener("touchmove",vm.touchMove)
				vm.canvas.removeEventListener("mousedown",vm.mouseUp)
				vm.canvas.removeEventListener("mousemove",vm.mouseMove)
			}

			document.body.removeEventListener("mouseup", vm.mouseUp, false);
			document.body.removeEventListener("touchcancel", vm.touchUp, false);
		},
		skipSignature() {
			this.modalTitle = "Skipping signature capture"
			if (!this.readonly) {
				this.sigPadOpen = true
				this.signatureTrail = []
				this.sigSkipped = true
				this.toggleFullScreen()
			}
		},
		getSignature() {

			this.modalTitle = "Sign your name please"
			if (!this.readonly) {
				this.$store.isUserDrawing = true
				this.sigPadOpen = true
				this.signatureTrail = []
				this.sigSkipped = false

				this.toggleFullScreen()

				let vm = this

				this.$nextTick(() => {
					vm.canvas = vm.$refs.sigCanvas

					vm.rect = vm.canvas.getBoundingClientRect()
					vm.context = vm.canvas.getContext("2d");

					vm.addEventListeners(vm.canvas)

				})
			}
		},
		mouseDown() {
			this.capturingMouse = true

			this.canvas = this.$refs.sigCanvas
			this.rect = this.canvas.getBoundingClientRect()
			this.context = this.canvas.getContext("2d");
		},
		touchDown() {
			this.mouseDown()
		},
		mouseMove(e) {
			//draw trail
			if (this.capturingMouse) 
				this.drawTrail(e.clientX,e.clientY)

		},
		touchMove(e) {
			e.preventDefault()

			if (this.capturingMouse)
				this.drawTrail(e.targetTouches[0].clientX,e.targetTouches[0].clientY)
		},
		drawTrail(x,y) {
			
			let position = {
				x: (x - this.rect.left),
				y: (y - this.rect.top)
			}

			if ("x" in this.lastPosition) {
				this.context.beginPath()
				this.context.moveTo(this.lastPosition.x, this.lastPosition.y)
				this.context.lineTo(position.x, position.y)
				this.context.stroke()
			}

			this.lastPosition = position

			this.signatureTrail.push(position)
		},
		mouseUp() {
			this.capturingMouse = false

			this.lastPosition = {}
			this.signatureTrail.push({})
		},
		touchUp() {
			this.mouseUp()
		},
		acceptSig() {
			this.$emit("input",JSON.stringify({
				dataUrl: this.canvas ? this.canvas.toDataURL() : "",
				trail: this.signatureTrail,
				name:this.signerName,
				sigSkipped: this.sigSkipped
			}))
			this.$store.isUserDrawing = false
			this.sigPadOpen = false
			this.toggleFullScreen()
			this.hasSignature = true
			this.lastPosition = {}

			this.renderDisplayCanvas()

		},
		clearPad() {
			if (this.context)
				this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
			this.lastPosition = {}
			this.signatureTrail = []
			this.hasSignature = false
		}
	},
	created() {
		this.setInternalValues()
	},
	destroyed() {
		this.removeEventListeners()
	}
}
</script>
<style type="text/css" scoped>

	canvas {
		box-shadow: inset 0 0 4px #efefef;
		border: 1px solid #ced4da;
		display: block;
	}

	canvas.capture-canvas {
		margin: auto;
	}

	input {
		width: 324px;
		display: block;
		margin: auto;
		margin-top: 10px;
	}
</style>